export default __webpack_public_path__ + "static/media/2.5840f7e5.webp";